<template lang="">
  <div class="row justify-content-center " >
    <div class="col-12 col-lg-12 col-md-12 col-xl-12">
      <div class="productheader">
        <div class="">
          <div class="premium_breakup-header d-flex justify-content-between align-items-center w-100 gap-3 p-2 rounded">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <img
                class="productImage"
                :src="insCompanyLogo"
                alt="Insurance Company Logo"
              />
              <!-- Premium Breakup -->
              <!-- <div class="d-flex align-items-center gap-1 premium_breakup_container" style="cursor: pointer;" @click="showBreakupmodal()" title="View Premium Breakup">
                <img src="@/assets/images/redirection.png" width="18" height="18" alt="Breakup Icon"/>
                <span class="text-primary fw-semibold small">Premium Breakup</span>
              </div> -->
            </div>


            <div class="d-flex align-items-center gap-2">
              <div class="d-flex flex-column align-items-center gap-1">
                <h2 class="mb-0 text-dark breakup_amount">
                  ₹ {{ formatToINR(totalPremiumWithTax) }}
                </h2>
                <button class="btn premium_breakup-modal" @click="showBreakupmodal()">PREMIUM BREAKUP</button>
              </div>
              <!-- Right Section: PDF Brochure -->
              <div class="text-center" v-if="selectedPlanData?.supportingData?.Messages?.brochureLink">
                <a
                  :href="selectedPlanData.supportingData.Messages.brochureLink"
                  target="_blank"
                  class="btn rounded-circle px-1 py-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Download Brochure"
                >
                  <img src="../../assets/images/pdf.svg" alt="Download PDF" class="pdficon" style="height: 32px; width: 32px;" />
                </a>
              </div>
            </div>

          </div>

          <div class="formobileview">
                <div class="single-quote my-2 headingcards d-flex flex-column justify-content-between gap-3">
                  <div>
                    <h6 class="mb-2 vehicle-header">
                      {{ motorProductType === '4W-Pvt' ? 'CAR DETAILS' : 'BIKE DETAILS' }}
                    </h6>
                    <p class="mb-0 d-flex gap-2 flex-wrap">
                      <span v-if="(this.userData?.vehicleNumber || this.requestJson?.product?.registrationDetails?.registrationNumber) && this.quoteCategory != 'New'">{{this.userData?.vehicleNumber || this.requestJson?.product?.registrationDetails?.registrationNumber}}&nbsp;&nbsp;|</span>
                      <span v-if="this.userData && (this.userData.vehicleNumber || this.userData?.rtoCode || this.userData?.city)">{{
                        this.userData?.vehicleNumber?.substring(0, 4) || this.userData?.rtoCode }} <span v-if="this.quoteCategory != 'New'">({{this.userData?.city?.toUpperCase()}})</span>&nbsp;&nbsp;|</span>
                      <span v-if="this.userData && this.userData.carMake?.makeDescription">{{
                        (this.userData.carMake?.makeDescription).toUpperCase() }}&nbsp;&nbsp;|</span>
                      <span v-if="this.userData && this.userData.model?.modelDesc">{{
                        (this.userData.model?.modelDesc).toUpperCase() }}&nbsp;&nbsp;| </span>
                      <span v-if="this.userData && this.userData.fuelType">{{
                        (this.userData.fuelType).toUpperCase()}}&nbsp;&nbsp;|</span>
                      <span v-if="this.userData && this.userData.variant?.variantDesc">{{
                        (this.userData.variant?.variantDesc).toUpperCase() }}&nbsp;&nbsp;| </span>
                      <span v-if="this.userData && (this.userData.MfgYear || this.requestJson?.product?.registrationDetails?.manufacturingYear)">MFG. YEAR {{this.userData?.MfgYear || this.requestJson?.product?.registrationDetails?.manufacturingYear}} </span> 
                    </p>
                  </div>
                  <div class="d-flex gap-2 inspection_required-container align-items-center" style="gap:20px" v-if="selectedPlanData?.productDetails?.inspectionDetails?.isInspectionRequired">
                    <p class="productSpan" style="font-weight: bold">
                      <img v-if="motorProductType == '4W-Pvt'" src="@/assets/images/inspection-icon.png"/> 
                      <img v-else src="@/assets/images/inspection-bike.png"/> 
                      <span class="pl-2">INSPECTION REQUIRED :</span>
                    </p>
                    <p class="inspection_status" style="font-weight: bold">{{selectedPlanData?.productDetails?.inspectionDetails?.isInspectionRequired ? "YES" : "NO"}}</p>
                  </div>
                </div>
              </div>
            </div>
          <div class="d-flex align-items-center flex-wrap gap-2">
                <!-- <h2 class="productName mt-2 mb-0">{{ this.productName}}</h2> -->
            <!-- <span class="productSpan">({{this.policyType}})</span> -->
            </div>
          <div class=" w-100 mt-2 ">
            <div class="d-flex justify-content-between mb-2" style="gap:20px" >
          <span class="productSpan">JOURNEY ID</span>
          <p class="wizard-hold d-flex gap-1 mb-0 align-items-center">
            <JourneyIdContainer :journey-id="journey_id" :show-label="false" />
          </p>
          </div>

            
          </div>
        </div>
        <div class="" v-if="requestJson!= undefined && requestJson.product != undefined && requestJson.product.idvDetails != undefined">
          <div class="d-flex justify-content-between mb-2" style="gap:20px" >
            <p class="productSpan " >PLAN NAME</p>
            <p class="journeyId" >{{(this.planName)?.toUpperCase()}}</p>
          </div>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" >
            <p class="productSpan " >POLICY HOLDER TYPE</p>
            <p class="journeyId" >{{(this.policyHolder).toUpperCase()}}</p>
          </div>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="quoteCategory !== 'New'">
            <p class="productSpan ">OWNERSHIP CHANGED IN LAST 12 MONTHS?</p>
            <p class="journeyId">{{isOwnerTransfer ? "YES" : "NO"}}</p>
          </div>
          <template v-if="this.policyType!=='StandaloneTP(1)'">
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="!['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(requestJson.product.insuranceAndProducts[0].policyType) && !isInvalid(requestJson.product.idvDetails.insuredDeclaredValue)">
              <p class="productSpan ">IDV COVER</p>
              <p class="journeyId">&#8377; {{formatIndianCurrency(requestJson.product.idvDetails.insuredDeclaredValue)}}</p>
            </div>
          </template>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.registrationDetails != undefined">
            <p class="productSpan ">REGISTRATION DATE</p>
            <p class="journeyId">{{formatDateToMonthString(requestJson.product.registrationDetails.registrationDate)}}</p>
          </div>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.registrationDetails != undefined">
            <p class="productSpan ">REGISTRATION NUMBER</p>
            <p class="journeyId">{{requestJson.product.registrationDetails.registrationNumber=='New' ? "NEW" : requestJson.product.registrationDetails.registrationNumber}}</p>
          </div>
          <template v-if="quoteCategory !== 'New'">
            <template v-if="this.policyType!=='StandaloneTP(1)'">
              <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.ncbDetails != undefined">
                <p class="productSpan ">CURRENT NCB %</p>
                <p class="journeyId" v-if="this.requestJson.product.ncbDetails.claimLastYearFlag && this.requestJson.product.ncbDetails.ncbPercentageLastYear==0">{{String(this.requestJson.product.ncbDetails.ncbPercentageLastYear).trim()}}%</p>
                <p v-else-if="userData!=undefined && userData.prePolicyGreaterThan90Days" class="journeyId">{{String(this.requestJson.product.ncbDetails.ncbPercentageLastYear).trim()}}%</p>
                <p v-else class="journeyId">{{!this.requestJson.product.ncbDetails.claimLastYearFlag && this.requestJson.product.ncbDetails.ncbPercentageLastYear==0 && requestJson.personalInformation.individualDetails[0].isOwnerTransfer ? '0' : String(selectedPlanData?.productDetails?.motorNCBPremium?.[0]?.nextNcbSlabDetails?.[0]?.nextNcbSlabApplicable ?? '').trim()}}%</p>
              </div>
            </template>
          </template>
          <!-- this.policyInfo.prevPolicyType
          this.policyInfo.prevPolicyInsurer
          this.policyInfo.prevPolicyTpInsurer -->
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="this.policyInfo?.prevPolicyType">
            <p class="productSpan ">PREVIOUS POLICY TYPE</p>
            <p class="journeyId">{{this.policyInfo.prevPolicyType}}</p>
          </div>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="this.policyInfo?.prevPolicyInsurerCode">
            <p class="productSpan ">PREVIOUS INSURER NAME</p>
            <div class="d-flex gap-1 align-items-center prev_insurer-detail">
              <p class="mb-0">{{ this.policyInfo?.prevPolicyInsurerCode || "" }}</p>
              <img src="@/assets/images/info-extra.png" width="16" height="16"/>
              <p class="mb-0 insurer_name">{{ this.policyInfo?.prevPolicyInsurer }}</p>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="this.policyInfo?.prevPolicyTpInsurerCode && this.policyInfo.prevPolicyType != 'COMPREHENSIVE'">
            <p class="productSpan ">TP INSURER NAME</p>
            <div class="d-flex gap-1 align-items-center prev_insurer-detail">
              <p class="mb-0">{{ this.policyInfo?.prevPolicyTpInsurerCode || "" }}</p>
              <img src="@/assets/images/info-extra.png" width="16" height="16"/>
              <p class="mb-0 insurer_name">{{ this.policyInfo?.prevPolicyTpInsurer }}</p>
            </div>
          </div>
          <template v-if="this.productName=='Comprehensive' && !(requestJson.product.previousPolicyDetails.previousPolicyOdExpiryDate && requestJson.product.previousPolicyDetails.previousPolicyTpExpiryDate)">
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.previousPolicyDetails != undefined">
            <p class="productSpan ">PREVIOUS POLICY EXPIRY DATE</p>
            <p class="journeyId">{{formatDateToMonthString(requestJson.product.previousPolicyDetails.previousPolicyEndDate)}}</p>
            </div>
          </template>
          <template v-if="this.policyType=='StandaloneOD(1)' && quoteResponseDetailsData!=undefined">
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="quoteResponseDetailsData?.quote_response_data?.productDetails?.previousPolicyDetails != undefined && quoteResponseDetailsData.quote_response_data.productDetails.previousPolicyDetails.previousPolicyOdExpiryDate && quoteResponseDetailsData.quote_response_data.productDetails.previousPolicyDetails.previousPolicyTpExpiryDate">
              <p class="productSpan ">OD POLICY EXPIRY DATE</p>
              <p class="journeyId">{{formatDateToMonthString(quoteResponseDetailsData.quote_response_data.productDetails.previousPolicyDetails.previousPolicyOdExpiryDate)}}</p>
            </div>
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="quoteResponseDetailsData?.quote_response_data?.productDetails?.previousPolicyDetails != undefined && quoteResponseDetailsData.quote_response_data.productDetails.previousPolicyDetails.previousPolicyTpExpiryDate">
              <p class="productSpan ">TP POLICY EXPIRY DATE</p>
              <p class="journeyId">{{formatDateToMonthString(quoteResponseDetailsData.quote_response_data.productDetails.previousPolicyDetails.previousPolicyTpExpiryDate)}}</p>
            </div>
            <!-- <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.previousPolicyDetails != undefined">
              <p class="productSpan ">Previous Policy Expiry Date</p>
              <p class="journeyId">{{formatDateToMonthString(requestJson.product.previousPolicyDetails.previousPolicyEndDate)}}</p>
            </div> -->
          </template>

          <template v-else>
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.previousPolicyDetails.previousPolicyOdExpiryDate && requestJson.product.previousPolicyDetails.previousPolicyTpExpiryDate">
              <p class="productSpan ">OD POLICY EXPIRY DATE</p>
              <p class="journeyId">{{formatDateToMonthString(requestJson.product.previousPolicyDetails.previousPolicyOdExpiryDate)}}</p>
            </div>
            <div class="d-flex justify-content-between mb-2" style="gap:20px" v-if="requestJson.product.previousPolicyDetails.previousPolicyTpExpiryDate && requestJson.product.previousPolicyDetails.previousPolicyOdExpiryDate">
              <p class="productSpan ">TP POLICY EXPIRY DATE</p>
              <p class="journeyId">{{formatDateToMonthString(requestJson.product.previousPolicyDetails.previousPolicyTpExpiryDate)}}</p>
            </div>
          </template>

          <template v-if="this.policyType=='StandaloneTP(1)' && !(requestJson.product.previousPolicyDetails.previousPolicyOdExpiryDate && requestJson.product.previousPolicyDetails.previousPolicyTpExpiryDate)">
            <div class="d-flex justify-content-between mb-2" style="gap:20px">
              <p class="productSpan ">PREVIOUS POLICY EXPIRY DATE</p>
              <p class="journeyId">{{formatDateToMonthString(requestJson.product.previousPolicyDetails.previousPolicyEndDate)}}</p>
            </div>
          </template>
        </div>
        
    </div>
  </div>

  <AmountBreakup v-if="this.openAmountBreakupflag" @emitClose="emitClose()" :journeyId="journey_id"/>
</template>
<script>
import AmountBreakup from "@/modals/amountBreakup.vue";
import backendApi from '@/apis/axios-backend';
export default {
  name: "productheader",
  components: {
    AmountBreakup,
  },
  props: ["reviewData", "quoteRequest", "quoteResponseDetails"],
  mounted() {
    this.motorProductType = this.$store.state.motorProductType;
    const journeyIdRaw = sessionStorage.getItem("journey_id");
    if (journeyIdRaw) {
      try {
        this.journey_id = JSON.parse(journeyIdRaw);
      } catch (e) {
        this.journey_id = journeyIdRaw;
      }
    }
    this.getSelectedPlanData();

    const userTypeRaw = sessionStorage.getItem("user-type");
    const quoteRequestRaw = sessionStorage.getItem("quote_request");
    let quoteRequest = null;
    if (quoteRequestRaw) {
      try {
        quoteRequest = JSON.parse(quoteRequestRaw);
      } catch (e) {
        quoteRequest = null;
      }
    }

    if (userTypeRaw) {
      try {
        this.policyHolder = JSON.parse(userTypeRaw);
      } catch (e) {
        this.policyHolder = userTypeRaw;
      }
    } else if (quoteRequest?.personalInformation?.individualDetails?.[0]) {
      this.policyHolder =
        quoteRequest.personalInformation.individualDetails[0].ownerBelongsToOrganizationFlag == false
          ? 'Individual'
          : 'Corporate';
    }

    if (quoteRequest) {
      this.requestJson = quoteRequest;
      this.isOwnerTransfer = this.requestJson?.personalInformation?.individualDetails?.[0]?.isOwnerTransfer;
    }
    this.quoteCategory = this.$store.state.quoteCategory ? this.$store.state.quoteCategory : this.userData?.quoteCategory ? this.userData?.quoteCategory : this.requestJson?.quoteCategory;
    this.checkSessionStorage();
    this.setVehicleDataByLooker();
    this.quoteResponseDetailsData = this.quoteResponseDetails;
    const dashboardJourneyRaw = sessionStorage.getItem("dashboardJourneyToProposal");
    if (dashboardJourneyRaw) {
      try {
        this.dashboardJourneyToProposal = JSON.parse(dashboardJourneyRaw);
      } catch (e) {
        this.dashboardJourneyToProposal = null;
      }
    }
    if(this.dashboardJourneyToProposal && this.dashboardJourneyToProposal.page=="proposal"){
      this.motorProductType = this.dashboardJourneyToProposal.vehicleType;
      this.getVehiclemakeFromDashboard(this.motorProductType)
    }
    if (sessionStorage.getItem("userData")) {
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      console.log(this.userData, "userData");
    }
    this.getCity();
    if(this.$store.state.quoteCategory !== 'New'){
      this.getPolicyInfo();
    }
  },
  data() {
    return {
      userData: {},
      openAmountBreakupflag: false,
      journey_id: "",
      selectedPlan: "",
      productName: "",
      planName: "",
      policyType: "",
      insCompanyLogo: "",
      totalPremiumWithTax: "",
      motorProductType: "",
      requestJson: {},
      policyHolder: "",
      selectedPlanData: (() => {
        try {
          const raw = sessionStorage.getItem('selected_plan_data');
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      })(),
      quoteCategory: "",
      quoteResponseDetailsData: "",
      dashboardJourneyToProposal: null,
      isOwnerTransfer: false,
      policyInfo: null
    };
  },
  methods: {
    premiumRound(amount){
      return Math.round(amount);
    },
    checkSessionStorage(){
      setInterval(() => {
        const planData = sessionStorage.getItem("selected_plan_data");

        if (!planData) {
          return;
        }else{
          this.selectedPlan = JSON.parse(planData);
        }
        if (!this.selectedPlan?.productDetails?.totalPremiumDetails?.[0]) {
          return;
        }
        const updatedPremiumRaw = sessionStorage.getItem("updated_premium");
        const updatedPlanData1 = updatedPremiumRaw ? JSON.parse(updatedPremiumRaw) : null;
        const currentPremium = this.selectedPlan.productDetails.totalPremiumDetails[0].totalPremiumWithTax;

        if(!updatedPlanData1){
          this.totalPremiumWithTax = currentPremium;
        }else{
          const updatedPremium = updatedPlanData1?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumWithTax;
          this.totalPremiumWithTax = updatedPremium ?? currentPremium;
        }
      }, 1000);
    },
    isInvalid(value) {
      const trimmed = typeof value === 'string' ? value.trim().toLowerCase() : value;
      return (
        trimmed === null ||
        trimmed === undefined ||
        trimmed === false ||
        trimmed === 0 ||
        trimmed === '' ||
        trimmed === 'null' ||
        trimmed === 'undefined' ||
        trimmed === 'false' ||
        (Array.isArray(trimmed) && trimmed.length === 0) ||
        (typeof trimmed === 'object' && !Array.isArray(trimmed) && Object.keys(trimmed).length === 0)
      );
    },
    getPolicyInfo(){
      const quoteRequestRaw = sessionStorage.getItem("quote_request");
      let quoteRequestPayload = null;
      if (quoteRequestRaw) {
        try {
          quoteRequestPayload = JSON.parse(quoteRequestRaw);
        } catch (e) {
          quoteRequestPayload = null;
        }
      }
      if (!quoteRequestPayload) {
        return;
      }
      let policyTypeList = this.motorProductType=='4W-Pvt' ? this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP : this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP2;
      let insurerList = this.$store.state.configData?.PREVIOUS_INSURER_LIST || [];

      let prevPolicyType = quoteRequestPayload?.product?.previousPolicyDetails?.previousCoverageType;
      let prevPolicyInsurer = quoteRequestPayload?.product?.previousPolicyDetails?.previousPolicyInsurer;
      let prevPolicyTpInsurer = quoteRequestPayload?.product?.previousPolicyDetails?.previousPolicyTpInsurer;

      this.policyInfo = {};
      this.policyInfo.prevPolicyType = policyTypeList && policyTypeList.find(policy => policy.VALUE == prevPolicyType)?.NAME?.toLowerCase().replace('policy', '')?.toUpperCase();

      this.policyInfo.prevPolicyInsurerCode = prevPolicyInsurer?.toUpperCase();
      this.policyInfo.prevPolicyInsurer = insurerList.find(insurer => insurer.manufacturer_id == prevPolicyInsurer)?.manufacturer_name?.toUpperCase();

      this.policyInfo.prevPolicyTpInsurerCode = prevPolicyTpInsurer?.toUpperCase();
      this.policyInfo.prevPolicyTpInsurer = insurerList.find(insurer => insurer.manufacturer_id == prevPolicyTpInsurer)?.manufacturer_name?.toUpperCase();
    },
    setVehicleDataByLooker(){
      if(this.reviewData && this.reviewData?.distributor?.channelType == 'B2B'){
        this.getVehiclemake()
      }
    },
    getCity(){
      if (!this.$store.state.token) {
        return;
      }
      // this.this.userData
      let reqBody= {
        category: "rto",
        rtoCode: this.reviewData?.product?.rtoLocationCode || this.userData?.vehicleNumber?.substring(0, 4) || this.userData?.rtoCode
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          }else if(response && response.data) {  
            let cityState = response.data.data.rto[0].city;
            this.userData.city = cityState;
            sessionStorage.setItem("userData", JSON.stringify(this.userData))
          }
      })
    },
    getVehiclemake(){
      this.userData = {};
      this.userData.rtoCode = this.reviewData?.product?.rtoLocationCode || this.userData?.vehicleNumber?.substring(0, 4);
      // this.this.userData
      let vehicleType = this.reviewData.product.motorProductType == '4W-Pvt' ? 1 : 2;
      this.motorProductType = this.reviewData.product.motorProductType;
      this.policyHolder = (this.quoteRequest?.quote_request_json?.personalInformation?.individualDetails[0]?.ownerBelongsToOrganizationFlag || this.quoteRequest?.personalInformation?.individualDetails[0]?.ownerBelongsToOrganizationFlag) ? 'Corporate' : 'Individual';
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          }else if(response && response.data) {  
            let makeModel = response.data.data.make.filter(veh => {              
              return veh.makeCode == this.reviewData.product.vehicleDetails.vehicleMakeCode
            });
            console.log("makeModel", makeModel);
            this.userData.carMake = {
              makeCode : makeModel[0].makeCode,
              makeDescription : makeModel[0].makeDescription
            }
            sessionStorage.setItem("userData", JSON.stringify(this.userData))
            this.getVehicleModel();                        
          }
      })
    },
    getVehicleModel(){
      let vehicleType;
      if(this.dashboardJourneyToProposal){
        vehicleType = this.dashboardJourneyToProposal.vehicleType == '4W-Pvt' ? 1 : 2;
      }else{
        vehicleType = this.reviewData.product.motorProductType == '4W-Pvt' ? 1 : 2;
      }
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType,
        make: this.userData.carMake.makeCode
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {  
            let makeModel = response.data.data.model.filter(veh => {    
              if(this.dashboardJourneyToProposal){
                return veh.modelCode == this.dashboardJourneyToProposal.vehicleData.model;
              } else{
                return veh.modelCode == this.reviewData.product.vehicleDetails.vehicleModelCode;
              }         
            });
            this.userData.model = {
              modelCode : makeModel[0]?.modelCode || null,
              modelDesc : makeModel[0]?.modelDesc || null
            };
            sessionStorage.setItem("userData", JSON.stringify(this.userData))
            this.getVehicleVariant();
          }
        });
    },
    getVehicleVariant(){
      let vehicleType;
      if(this.dashboardJourneyToProposal){
        this.userData.fuelType = this.dashboardJourneyToProposal.vehicleData.fuelType
        vehicleType = this.dashboardJourneyToProposal.vehicleType == '4W-Pvt' ? 1 : 2;
      }else{
        this.userData.fuelType = this.reviewData.product.vehicleDetails.vehicleFuelType;
        vehicleType = this.reviewData.product.motorProductType == '4W-Pvt' ? 1 : 2;
      }
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType,
        make: this.userData.carMake.makeCode,
        model: this.userData.model.modelCode,
        fuelType: this.userData.fuelType
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          } else if(response && response.data) {  
            let makeModel = response.data.data.variant.filter(veh => {           
              if(this.dashboardJourneyToProposal){
                return veh.variantCode == this.dashboardJourneyToProposal.vehicleData.variant;
              }else{
                return veh.variantCode == this.reviewData.product.vehicleDetails.vehicleVariantCode;
              }
            });
            this.userData.variant = {
              variantCode : makeModel[0]?.variantCode || null,
              variantDesc : makeModel[0]?.variantDesc || null
            };
            sessionStorage.setItem("userData", JSON.stringify(this.userData))
            if(this.dashboardJourneyToProposal){
              this.userData.RegDate = this.dashboardJourneyToProposal.vehicleData.regDate
              // this.userData.fuelType
              // this.userData.variant?.variantDesc
              // this.userData.RegDate
            }else{
              this.userData.RegDate = this.reviewData.product.registrationDetails.registrationDate;
            }
          }
        });
    },

    getVehiclemakeFromDashboard(){
      this.userData = {};
      this.userData.rtoCode = this.dashboardJourneyToProposal.vehicleData.rtoCode;
      let vehicleType = this.dashboardJourneyToProposal.vehicleType == '4W-Pvt' ? 1 : 2;
      let reqBody= {
        category: "vehicle",
        vehicleType: vehicleType
      }

      backendApi("vehicleSearch", [],{"Authorization":`Bearer ${ this.$store.state.token}`}, "get", {}, reqBody)
        .then((response) => {
          if(response.data.errors.length > 0) {
            const msg = [];
            if(response.data.errors[0].errorDisplayMsg !=""){
              msg.push(response.data.errors[0].errorDisplayMsg);
            }
          }else if(response && response.data) {  
            let makeModel = response.data.data.make.filter(veh => {              
              return veh.makeCode == this.dashboardJourneyToProposal.vehicleData.make
            });
            this.userData.carMake = {
              makeCode : makeModel[0].makeCode,
              makeDescription : makeModel[0].makeDescription
            }
            this.getVehicleModel();                        
          }
      })
    },
    convertToThousandsWithKorL(number) {
      const number1 = parseFloat(number);
      if (number1 >= 100000) {
        // 1 lakh (100,000) or more
        return (number1 / 100000).toFixed(1) + 'L';
      } else if (number1 >= 1000) {
        // 1 thousand (1,000) or more
        return (number1 / 1000).toFixed(1) + 'k';
      }
      return number1.toString();
    },
    formatDateToMonthString(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-').toUpperCase();
    },
    // Date fromatting to DD-MM-YYYY Fromat
    formatDate(date) {
      const dateObj = new Date(date);
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    },
    showBreakupmodal() {
      console.log("clicked-------");
      this.openAmountBreakupflag = true;
    },
    emitClose() {
      this.openAmountBreakupflag = false;
    },
    getSelectedPlanData() {
      //  An interval to check for the selected plan
      const timer = setInterval(() => {
        const planData = sessionStorage.getItem("selected_plan_data");
        if (planData) {
          this.selectedPlan = JSON.parse(planData);
          if (this.selectedPlan) {
            clearInterval(timer);
            this.productName =
              this.selectedPlan.insuranceAndProducts.productName == 'New' ? this.selectedPlan.insuranceAndProducts.policyType : this.selectedPlan.insuranceAndProducts.productName;
            this.policyType = this.selectedPlan.insuranceAndProducts.policyType;
            this.planName = this.selectedPlan.productDetails.planOption?.planName;
            this.insCompanyLogo =
              this.selectedPlan.supportingData.insCompanyLogo;
            this.totalPremiumWithTax =
              this.selectedPlan.productDetails.totalPremiumDetails[0].totalPremiumWithTax;
          }
        }
      }, 200);
    },
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatIndianCurrency(num) {
      // Handle undefined, null, or non-numeric values
      if (num === undefined || num === null || isNaN(num)) {
        num = 0;
      }
      
      // Convert to string and split into integer and decimal parts
      let [integerPart, decimalPart] = num.toString().split("."); 
      let lastThree = integerPart.slice(-3);
      let rest = integerPart.slice(0, -3);

      if (rest !== '') {
        rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      }
      let formattedDecimal = decimalPart ? "." + parseFloat("0." + decimalPart).toFixed(2).split(".")[1] : "";
      return rest !== '' ? rest + ',' + lastThree + formattedDecimal : lastThree + formattedDecimal;
    },
    formatDateChange(userDate){
      const date = new Date(userDate);
      const formattedDate = `${('0' + date.getDate()).slice(-2)}-${('0' + (date.getMonth() + 1)).slice(-2)}-${date.getFullYear()}`;
      return formattedDate;
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/productDetailsHeader.scss";
@import "../../assets/scss/components/form-wizard.scss";
.show-breakup-link {
  font-size: 12px;
  // text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;
  color: $main-bg;
}
.breakup_amount {
  font-size: 1.2rem;
  font-weight: 600;
}
.premium_breakup-modal{
  font-size: 11px;
  color: $main-bg;
  background-color: $base-dark-text;
  // border-radius: 50px;
  padding: 4px 8px !important;
}
.premium_breakup-header{
  border: 1px solid $border-color !important;
}
.premium_breakup_container span {
  font-size: 0.75rem;
  color: $base-dark-text !important;
  width: 120px;
}

.productImage {
  height: 40px;
  width: auto;
}
.prev_insurer-detail {
  cursor: default;
  position: relative;

  &:hover .insurer_name {
    opacity: 1;
    visibility: visible;
  }

  .insurer_name {
    background-color: $commonColor;
    border-radius: 8px;
    padding: 6px 8px;
    position: absolute;
    top: -30%;
    right: 0%;
    transform: translateX(0%) translateY(-100%);
    width: 250px !important;
    text-align: center;
    opacity: 0;
    visibility: hidden; // fix from 'none'
    transition: all 0.2s ease-in-out;
    border: 1px solid $base-dark-text;
    box-shadow: 4px 4px 4px 0 rgba(0,0,0,0.1);
    font-size: 12px !important;
    // Prevent hover from triggering on this element
    pointer-events: none;
  }
}

.pdficon {
  height: 20px;
}

.dark .show-breakup-link {
  color: $main-bg !important;
}
.reference_number,
.translate_jid{
  color: $main-bg !important;
}
.request_Id{
  position: relative;
  font-size: 11px;
  color: $commonColorDark;
  border-radius: 8px;

  img{
    position: absolute;
    top: -2px;
    left: -28px;
    margin-left: auto;
    cursor: pointer;
    border: none;
    width: 20px;
    height: 20px;
  }
  .copy-icon{
    transform: scale(1.5);
    height: 16px !important;
  }
}
.translate_jid{
  transform: translateX(-12px);
}

  .copy_container{
    position: relative;
    img{
      position: absolute;
      top: -2px;
      left: -15px;
      margin-left: auto;
      cursor: pointer;
      border: none;
      width: 20px;
      height: 20px;
    }
    .copy-icon{
      transform: scale(1.2);
      height: 16px !important;
    }
    .copy-icon-tick{
      transform: scale(1);
      margin-left: auto !important;
    }
    .copy_tooltip{
      opacity: 0;
      visibility: hidden;
      position: absolute;
      top: -32px;
      left: -28px;
      font-size: 14px;
      color: $commonColor;
      background-color: $cardBackgroundDark;
      z-index: 10;
    }
    &:hover{
      .copy_tooltip{
        visibility: visible;
        opacity: 1;
      }
    }
  }
.single-quote span {
    font-size: 12px;
    color: $text-color;
   
}
.vehicle-header{
  font-weight: 800 !important;
}
.inspection_required-container{
  // padding: 8px 0;
  border-radius: 4px;
  p, span{
    margin-bottom: 0;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #EC920F !important;
  }
  img{
    margin-right: 6px;
    width: 30px !important;
    height: auto !important;
  }
}
.dark {
  .doticon{
    filter: invert(1) !important;
  }
  .copy-icon{
    filter: invert(1) !important;
  }
  .premium_breakup-header{
    border: none !important;
    background-color: $commonColorDark !important;
    .breakup_amount{
      color: $base-dark-text !important;
    }
  }
  .prev_insurer-detail{
    p{
      color: $commonColor !important;
    }
    .insurer_name{
      background-color: $cardBackgroundDark !important;
      border: 1px solid $text-darkColor !important;
    }
  }
  .productheader{
      *:not(.show-breakup-link, .breakup_amount, .premium_breakup-modal, .productSpan span, .inspection_status, .reference_number, .translate_jid){
        color: $text-darkColor !important;
      }
      .premium_breakup-modal{
        background-color: $header-dark-bg !important;
      }
      .reference_number,
      .translate_jid{
        color: $main-bg !important;
      }
      
    }
    .productSpan{
        color: $base-dark-text !important;
      }
      .journeyId{
        color: $base-dark-text !important;
      }

  .inspection_required-container{
    .productSpan, .inspection_status{
      color: #EC920F !important;
    }
  }
}

</style>
